export const toggleReviewMode = (payload = false) => {
    return {type: 'TOGGLE_REVIEW_MODE', payload};
};

export const updateContractCondition = (id, isActive, listIdx) => {
    const idAsArray = id.split('_');
    const currentID = +idAsArray[idAsArray.length - 1];
    const payload = {id: currentID, isActive, listIdx};
    return {type: 'UPDATE_CONDITION_OPTION', payload};
};